function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
//
//
//
//

import Vue from 'vue';
import { getRuleText, get } from '@changba/funny';
import { defineComponent } from '../utils/create';
import { props } from './props';
import EggConfig from '../egg-config';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "render",
    staticClass: "text-render"
  });
};
var staticRenderFns = [];
export default defineComponent({
  _scopeId: 'data-v-3d3cf008',
  render,
  name: 'CbRichTextRender',
  props,
  data() {
    return {
      renderResolver: []
    };
  },
  mounted() {
    this.renderRichText();
  },
  methods: {
    renderRichText() {
      var _this = this;
      return _asyncToGenerator(function* () {
        var rootEl = _this.$refs.render;
        if (!rootEl) {
          return;
        }
        rootEl.innerHTML = yield _this.getContent();
        var eggConfigEls = [...rootEl.querySelectorAll('code')];
        if (eggConfigEls.length === 0) {
          return;
        }
        eggConfigEls.forEach(codeEl => {
          // 定义匹配解析的规则
          var regExp = /((录播)|(包房))彩蛋ID[:：]\s*([A-Za-z_0-9]{11})/i;
          var text = codeEl.innerText.trim();
          var res = text.match(regExp);
          if (!Array.isArray(res)) {
            return;
          }
          // ((录播)|(包房)) 第一组的结果，第二组的结果(录播)，第三组的结果(包房)，第四组的结果([A-Za-z_0-9]{11})
          var type = res[1];
          var eggId = res[4];
          var fragmentApp = _this.renderEggConfig(type, eggId);
          codeEl.replaceWith(fragmentApp.$el);
        });
      })();
    },
    getContent() {
      var _this2 = this;
      return _asyncToGenerator(function* () {
        var isSite = ['site-prod', 'site-dev'].includes(process.env.NODE_ENV);
        var text = yield isSite ? _this2.getMockRichText() : _this2.getServerRichTextConfig();
        return text;
      })();
    },
    getMockRichText() {
      return _asyncToGenerator(function* () {
        var resp = yield get({
          url: 'https://yapi.changbaops.com/mock/32/www/api/v1/rule/detail',
          ignoreBaseURL: true
        });
        return resp.data.content;
      })();
    },
    getServerRichTextConfig() {
      var _this3 = this;
      return _asyncToGenerator(function* () {
        if (typeof _this3.getRemoteText === 'function') {
          var text = yield _this3.getRemoteText();
          return text;
        }
        var {
          data,
          code
        } = yield getRuleText({
          actId: _this3.actId,
          isPreview: _this3.isPreview,
          contentId: _this3.contentId
        });
        if (code === 0) {
          return data.content;
        }
        return '查询规则失败';
      })();
    },
    renderEggConfig(type, eggId) {
      var el = document.createElement('div');
      var tpl = new Vue({
        render: h => h(EggConfig, {
          props: {
            isPreview: this.isPreview,
            [type === '包房' ? 'roomEggs' : 'workEggs']: [eggId]
          }
        })
      });
      this.renderResolver.push(tpl);
      return tpl.$mount(el);
    },
    beforeDestroy() {
      this.renderResolver.forEach(app => {
        app.$destroy();
      });
    }
  }
});